// extracted by mini-css-extract-plugin
export default {"mosaic":"BMosaic-module_mosaic_ed93a06b"};